"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _CardBase = _interopRequireDefault(require("../Card/CardBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Private subcomponent for use within QuickLinks.
 *
 * Restyled Card with identical behaviour to Card, but themed according to the
 * QuickLinksCard theme rather than the Card theme.
 */const QuickLinksList = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    tokens,
    variant,
    children
  } = _ref;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('QuickLinksCard', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardBase.default, {
    tokens: themeTokens,
    ref: ref,
    children: children
  });
});
QuickLinksList.displayName = 'QuickLinksList';
QuickLinksList.propTypes = {
  tokens: (0, _utils.getTokensPropType)('QuickLinksCard'),
  variant: _utils.variantProp.propType,
  children: _propTypes.default.node
};
var _default = exports.default = QuickLinksList;